import { css, CSSResult } from 'lit'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorBackground, csColorFunctional, csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'


export const cseAlert = {
  borderRadius: css`var(--cse-alert-border-radius, ${csBorder.radiusMinimal})`,
  color: css`var(--cse-alert-color, ${csColorText.body})`,
  columnGap: css`var(--cse-alert-column-gap, ${csSpacing.spacing05})`,
  errorBackgroundColor: css`var(--cse-alert-error-background-color, ${csColorBackground.error})`,
  errorColor: css`var(--cse-alert-error-color, ${csColorFunctional.error})`,
  infoBackgroundColor: css`var(--cse-alert-info-background-color, ${csColorBackground.info})`,
  infoColor: css`var(--cse-alert-info-color, ${csColorFunctional.info})`,
  padding: css`var(--cse-alert-padding, ${csSpacing.spacing06})`,
  rowGap: css`var(--cse-alert-row-gap, ${csSpacing.spacing04})`,
  successBackgroundColor: css`var(--cse-alert-success-background-color, ${csColorBackground.success})`,
  successColor: css`var(--cse-alert-success-color, ${csColorFunctional.success})`,
  warningBackgroundColor: css`var(--cse-alert-warning-background-color, ${csColorBackground.warning})`,
  warningColor: css`var(--cse-alert-warning-color, ${csColorFunctional.warning})`
}


export const style: CSSResult = css`
  .cse-alert {
    --cse-link-primary-color: ${csColorText.body};

    border-radius: ${cseAlert.borderRadius};
    display: flex;
    column-gap: ${cseAlert.columnGap};
    padding: ${cseAlert.padding};
    width: 100%;
  }

  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    row-gap: ${cseAlert.rowGap};
  }

  .title, .description {
    --cse-text-color: ${cseAlert.color};
  }

  .variant-error {
    background: ${cseAlert.errorBackgroundColor};
  }

  .variant-info {
    background: ${cseAlert.infoBackgroundColor};
  }

  .variant-success {
    background: ${cseAlert.successBackgroundColor};
  }

  .variant-warning {
    background: ${cseAlert.warningBackgroundColor};
  }

  [icon-role="cse-alert.error"] {
    color: ${cseAlert.errorColor};
  }

  [icon-role="cse-alert.info"] {
    color: ${cseAlert.infoColor};
  }

  [icon-role="cse-alert.success"] {
    color: ${cseAlert.successColor};
  }

  [icon-role="cse-alert.warning"] {
    color: ${cseAlert.warningColor};
  }
`
